import ArrowForward from '@mui/icons-material/ArrowForward';
import { Card, Stack, Typography } from '@mui/material';
import React from 'react';

import { theme } from '../../theme/theme';

interface OwnProps {
  href: string;
  children: React.ReactNode;
  prompt?: string;
  'data-cy'?: string;
}

const SeeAllCard: React.FC<OwnProps> = ({
  href,
  children,
  prompt = "Don't see what you're looking for?",
  ...rest
}) => (
  <Card
    sx={{
      borderRadius: '20px',
      flexShrink: 0,
      height: '100%',
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: `2px dashed ${theme.palette.primary.light}`,
    }}
    data-cy="see-all-card"
    {...rest}
  >
    <Stack
      component="a"
      href={href}
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={{ xs: 1, sm: 2 }}
      sx={{
        height: '100%',
        boxSizing: 'border-box',
        textDecoration: 'none',
        padding: { xs: '1.25rem 1rem', sm: '2rem 1.5rem' },
        textAlign: 'center',
        transition: 'background-color 120ms ease-in-out',
        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.55)' },
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.secondary.main}`,
          outlineOffset: '-4px',
        },
      }}
    >
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: '0.9rem',
          lineHeight: 1.3,
          color: '#555',
        }}
      >
        {prompt}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: '1.1rem', sm: '1.2rem' },
            lineHeight: 1.2,
            color: theme.palette.primary.main,
          }}
        >
          {children}
        </Typography>
        <ArrowForward sx={{ color: theme.palette.primary.main }} />
      </Stack>
    </Stack>
  </Card>
);

export default SeeAllCard;
